/**
 * Vehicle steering position values
 */
export enum VehicleSteeringPositionEnum {
	LEFT_HAND_DRIVE = 'left_hand_drive',
	RIGHT_HAND_DRIVE = 'right_hand_drive',
	CENTER = 'center',
}
